import { required } from '@corporate-tailwind/corp-form';
import { AddressDto, AddressSchema } from './address.model';
import { SelectCode } from '@corporate-tailwind/model';
import { CountryDto } from './country.model';
import { CustomerIdentityProofDto, CustomerIdentityProofSchema } from './customer-identity-proof.model';
import { CustomerEmailValidationDto, CustomerEmailValidationSchema } from './customer-email-validation.model';

export class CustomerBaseDto {
    id: number | null = null;
    lastName: string | null = null;
    firstName: string | null = null;
    email: string | null = null;
    phone: string | null = null;
    gender: string | null = null;
    languageCode: string | null = null;
    placeOfBirth: string | null = null;
    isScreeningOk: boolean | null = null;
    isMailConfirmed: boolean | null = null;
    isAskMailConfirmed: boolean | null = null;
    dateOfBirth: Date | null = null;
    dateCreated: Date | null = null;
    dateUpdated: Date | null = null;
}

export class CustomerDto extends CustomerBaseDto {
    nationality: CountryDto | null = null;
    address: AddressDto | null = null;
    identityProof: CustomerIdentityProofDto | null = null;
    emailValidation: CustomerEmailValidationDto | null = null;
}

export class CustomerSchema extends CustomerDto {
    static schema = {
        id: { type: Number, builderOption: required },
        lastName: { type: String, builderOption: required },
        firstName: { type: String, builderOption: required },
        email: { type: String, builderOption: required },
        phone: { type: String, builderOption: required },
        gender: { type: String, builderOption: required },
        languageCode: { type: String, builderOption: required },
        placeOfBirth: { type: String, builderOption: required },
        isScreeningOk: { type: Boolean, builderOption: null },
        isMailConfirmed: { type: Boolean, builderOption: null },
        isAskMailConfirmed: { type: Boolean, builderOption: null },
        dateOfBirth: { type: Date, builderOption: required },
        dateCreated: { type: Date, builderOption: required },
        dateUpdated: { type: Date, builderOption: required },

        nationality: { type: CountryDto, builderOption: required },
        address: { type: AddressSchema, builderOption: required },
        identityProof:  { type: CustomerIdentityProofSchema, builderOption: required },
        emailValidation:  { type: CustomerEmailValidationSchema, builderOption: required }, 

        // itsMeId: { type: String, builderOption: null },
        // identityDocumentNumber: { type: String, builderOption: null },
        // identityDocumentType: { type: String, builderOption: null },
        
        // address: { type: AddressSchema, builderOption: required },
        // emailValidationToken: { type: String, builderOption: null },
        // emailValidationDateSend: { type: Date, builderOption: null },
        // emailValidationIsConfirmed: { type: Boolean, builderOption: null },
        // emailValidationDateConfirmed: { type: Date, builderOption: null },
        

    };
}

export class CustomerDtoForValidation extends CustomerDto {
    mailValidation: SelectCode[] | null = null;
}



// export class CustomerItsMeDto extends CustomerBaseDto {}

// export class CustomerItsMeSchema extends CustomerItsMeDto {
//     static schema = {
//         lastName: { type: String, builderOption: required },
//         firstName: { type: String, builderOption: required },
//         email: { type: String, builderOption: required },
//     };
// }
